__turbopack_context__.v({
  "neutral": "Section-module__7f9b0G__neutral",
  "primaryDark": "Section-module__7f9b0G__primaryDark",
  "section": "Section-module__7f9b0G__section",
  "sectionBg": "Section-module__7f9b0G__sectionBg",
  "variantBreadcrumb": "Section-module__7f9b0G__variantBreadcrumb",
  "variantCover": "Section-module__7f9b0G__variantCover",
  "variantDefault": "Section-module__7f9b0G__variantDefault",
  "variantIntroduction": "Section-module__7f9b0G__variantIntroduction",
});
